// extracted by mini-css-extract-plugin
export default {"markdownBody":"MarkdownPreview_markdownBody__Exq+8"};